export const featuredTestimonial = {
  author: 'Renault',
  quote:
    "Ma voiture était très sale. Pas nettoyée depuis le retour des vacances, elle avait servi pour un déménagement et mon enfant avait renversé son lait au chocolat sur un siège… Je recommande vivement.",
};

export const testimonials = [
  { author: 'Desson', quote: 'Nettoyage intérieur et extérieur de nos 2 véhicules. Discrétion et professionnalisme.' },
  { author: 'MJ 92', quote: 'Super travail. Ma voiture a retrouvé une nouvelle jeunesse… et il y avait du boulot !' },
  { author: 'David P', quote: 'Nettoyage intérieur premium pour un Partner en très sale état. RDV à l’heure, travail soigné.' },
  { author: 'Cédric Tetu', quote: 'Rénovation des optiques de ma Passat. Sérieux, ponctuel, à l’écoute. Je recommande à 200 %.' },
  { author: 'Véronique', quote: 'Du très bon travail, un vrai coup de jeune pour notre véhicule de 2004.' },
  { author: 'Suarez', quote: 'Véhicule impeccable au bout de 2h30 de travail. Quelle joie de monter dans une voiture propre.' },
  { author: 'Fouquet', quote: 'Super travail sur mon Opel Astra. Très professionnel, à la prochaine !' },
  { author: 'Aubineau', quote: 'Travail soigné, très discret. Service pour deux voitures, très satisfait.' },
  { author: 'Hueber', quote: 'Personne sympa et sérieuse, très bon travail. Je recommande.' },
  { author: 'Bourdt', quote: '308 CC bleue très propre. Très bon travail, très gentil, mérite plus de travail.' },
];
